export default __webpack_public_path__ + "static/media/clustermanagement_openapi.2a85c3ae.yaml";